import * as actionTypes from './actionTypes';

export const fetchUser = () => ({ type: actionTypes.FETCH_USER });

export const fetchUserSuccess = user => ({
  type: actionTypes.FETCH_USER_SUCCESS,
  user
});

export const fetchUserFail = error => ({
  type: actionTypes.FETCH_USER_FAIL,
  error
});



// WEBPACK FOOTER //
// ./app/javascript/app/store/actions/users.js